import { render, staticRenderFns } from "./ReportPurchaseGeneral.vue?vue&type=template&id=3cbec98c&scoped=true"
import script from "./ReportPurchaseGeneral.vue?vue&type=script&lang=js"
export * from "./ReportPurchaseGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbec98c",
  null
  
)

export default component.exports